<template>
  <div class="face-search-slot">
    <div class="face-search-slot__header">
      <label class="face-search-slot__label" for="provider-select">
        {{ $t('ntechlab.provider') }}
      </label>
      <v-select
        id="provider-select"
        v-model="provider"
        :options="providers"
        :placeholder="$t('ntechlab.provider_section')"
      />
    </div>

    <div class="face-search-slot__body">
      <matcher v-if="provider === 'Luna'" />
      <ntechlab v-else-if="provider === 'Ntechlab'" allow-map-drag />
      <div v-else class="face-search-slot__empty noselect">
        <feather-icon icon="SearchIcon" size="28" />
        <span>{{ $t('ntechlab.provider_section') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Matcher from "./Matcher/Index.vue";
import ntechlab from "@/components/NtechlabSearchFace/index.vue";

export default {
  components: {
    Matcher,
    vSelect,
    ntechlab,
  },
  data() {
    return {
      providers: ['Luna', 'Ntechlab'],
      provider: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.face-search-slot {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.face-search-slot__header {
  flex: 0 0 auto;
  padding: 1rem 1rem 0.5rem;
}

.face-search-slot__label {
  display: block;
  margin-bottom: 0.35rem;
}

.face-search-slot__body {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;

  > * {
    flex: 1 1 0;
    min-height: 0;
  }
}

.face-search-slot__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #a5a5a5;

  .dark-layout & {
    color: var(--third-light);
  }
}
</style>
